<template>
  <el-card class="list-selector">
    <ul class="list-selector-list">
      <li @click="swatchAdminCommunityId({ communityId: '', name: '全部' })"
        :class="{ 'selected': adminCommunityInfo.communityId === '' }">
        {{ $t('common.all') }}
      </li>
      <li v-for="(item, index) in adminCommunityInfo.communitys" :key="index"
        @click="swatchAdminCommunityId(item)"
        :class="{ 'selected': adminCommunityInfo.communityId == item.communityId }">
        {{ item.name }}
      </li>
    </ul>
  </el-card>
</template>

<script>
import { getAdminCommunityList } from '@/api/shop/adminCommunityApi'
import { getShopId } from '@/api/shop/shopApi'
console.log(getShopId)

export default {
  name: 'AdminCommunity',
  data() {
    return {
      adminCommunityInfo: {
        communitys: [],
        communityId: ''
      }
    }
  },
  created() {
    this._listAdminCommunitys(1, 100)
  },
  methods: {
    async _listAdminCommunitys(page, rows) {
      try {
        const res = await getAdminCommunityList({ page, row: rows })
        this.adminCommunityInfo.communitys = res.data
      } catch (error) {
        console.error('获取小区列表失败:', error)
      }
    },
    swatchAdminCommunityId(community) {
      this.adminCommunityInfo.communityId = community.communityId
      this.$emit('community-change', community)
    }
  }
}
</script>

<style scoped>
/* 使用全局 list-selector 样式，无需自定义样式 */
</style>